module.exports = __webpack_public_path__ + "static/media/it-big.080ac7b5.svg";